export default class OrderDetails {
    init() {
        $('.delete-question').on('click', function () {
            return confirm('Wirklich löschen?');
        });
    };
};